<template>
    <my-popup :visible.sync="show">
        <type-wrapper class="contact-popup" padding>
            <type-grid row="1">
                <!-- <type-title large>联系我们</type-title> -->
            	<type-title large>Contact Us</type-title>
            </type-grid>
            <type-grid row="1">
                <!-- <type-content large center>请留下您的联系方式，如果一拍即合，我们会马上联系您！</type-content> -->
                <type-content large center>Please leave your contact information, if it is a match, we will contact you immediately!</type-content>
            </type-grid>
            <type-grid row="1" style="margin: 10px 0;">
            	<type-input v-model="name" whitebackdrop placeholder="Name"></type-input>
            </type-grid>
            <type-grid row="1" style="margin: 10px 0;">
            	<type-input v-model="email" whitebackdrop placeholder="Email"></type-input>
            </type-grid>
            <type-grid row="1" style="margin: 10px 0;">
            	<type-input v-model="mobile" whitebackdrop  :maxlength="mobileMaxlength" prefix placeholder="Phone">
            		<div slot="prefix" @click="changePre">{{ mobilePre }}</div>
            	</type-input>
            </type-grid>
            <type-grid row="1" style="margin: 10px 0 0;">
                <!-- <type-button border @click="submitInfo">确定</type-button> -->
                <type-button whitebackdrop border @click="submitInfo">Sure</type-button>
            </type-grid>
        </type-wrapper>
    </my-popup>
</template>

<script>
	export default {
		name: 'contact',
		data() {
			return {
				// name: '',
				// email: '',
				// mobile: '',
				name: '刘',
				email: '1@qq.com',
				mobile: '3036283826',
				show: false,
				mobilePre: '+1',
                closeResolve: null,
				mobileMaxlength: '10',
				originalOverflow: ''
			}
		},
		methods: {
			showContact() {
				return new Promise(resolve => {
                    this.show = true;
                    this.closeResolve = resolve;
                    this.originalOverflow = document.body.style.overflow;
                    document.body.style.overflow = 'hidden';
				});
			},
			changePre() {
				if (this.mobilePre === '+1') {
					this.mobilePre = '+86';
					this.mobileMaxlength = '11';
				} else {
					this.mobilePre = '+1';
					this.mobileMaxlength = '10';
					if (this.mobile.length > 10) {
						this.mobile = this.mobile.slice(0, 10);
					}
				}
			},
			submitInfo() {
				const data = {
					name: this.name,
					email: this.email,
					mobile: (this.mobilePre === '+1' ? '1' : '+86') + this.mobile
				};
				const result = this.$verify.verify(data);
				// console.log('数据', JSON.parse(JSON.stringify(data)), '验证', JSON.parse(JSON.stringify(result)))
				if (result.tip) {
					this.$message(result.tip);
				} else {
					const content = Object.keys(data).map(key => `${key}=${data[key]}`).join('&');
					this.$http.user.report_bug(content).then(res => {
						if (res.status === 'success') {
							const _data = {
                                ...data,
								time: this.$time.now.timestamp
							};
                            document.body.style.overflow = this.originalOverflow;
                            this.show = false;
                            this.originalOverflow = '';
							this.$message('提交成功');
							this.$userInfo.setData(_data);
                            if (this.closeResolve && typeof this.closeResolve) {
                                this.closeResolve(_data);
                            }
						}
					});
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.contact-popup{
		width: calc(100vw - 90px);
		max-width: 400px;
		min-width: 240px;
		background-color: #FFFFFF;
	}
</style>